var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58669 3.09232C9.99311 3.03223 10.4124 3 10.8442 3C15.9492 3 19.299 7.50484 20.4244 9.28682C20.5607 9.5025 20.6288 9.61034 20.6669 9.77667C20.6955 9.90159 20.6955 10.0987 20.6668 10.2236C20.6287 10.3899 20.5601 10.4985 20.4229 10.7156C20.1231 11.1901 19.6659 11.8571 19.0602 12.5805M5.56807 4.71504C3.406 6.1817 1.9382 8.21938 1.26486 9.28528C1.12803 9.50187 1.05962 9.61016 1.02149 9.77648C0.992847 9.9014 0.992836 10.0984 1.02146 10.2234C1.05958 10.3897 1.12768 10.4975 1.26388 10.7132C2.38929 12.4952 5.73916 17 10.8442 17C12.9026 17 14.6756 16.2676 16.1326 15.2766M1.84417 1L19.8442 19M8.72285 7.87868C8.17995 8.42157 7.84417 9.17157 7.84417 10C7.84417 11.6569 9.18731 13 10.8442 13C11.6726 13 12.4226 12.6642 12.9655 12.1213",
    stroke: "#9A9A9A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseIcon);
export default __webpack_public_path__ + "static/media/eye_close_icon.e144588dff4f579e32a55cb5d0628654.svg";
export { ForwardRef as ReactComponent };